import { customAlphabet, urlAlphabet } from "nanoid"

const nanoid = customAlphabet(urlAlphabet, 11)

const newId = () => nanoid()

export default newId
